import { useState, useEffect, useCallback } from 'react';
import { initTheme, setStoredTheme } from '../../utils/theme';
export function useTheme() {
    const [theme, setThemeState] = useState(() => initTheme());
    useEffect(() => {
        setStoredTheme(theme);
    }, [theme]);
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'hodito-theme' && e.newValue) {
                const mapped = e.newValue === 'light' ? 'hodito-light'
                    : e.newValue === 'dark' ? 'hodito-dark'
                        : e.newValue;
                if (mapped === 'hodito-light' || mapped === 'hodito-dark') {
                    setThemeState(mapped);
                }
            }
        };
        const handleThemeChange = (e) => {
            const detail = e.detail;
            if (detail === 'hodito-light' || detail === 'hodito-dark') {
                setThemeState(detail);
            }
        };
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themechange', handleThemeChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themechange', handleThemeChange);
        };
    }, []);
    const toggleTheme = useCallback(() => {
        setThemeState(prev => prev === 'hodito-light' ? 'hodito-dark' : 'hodito-light');
    }, []);
    const isDark = theme === 'hodito-dark';
    return { theme, toggleTheme, isDark };
}
